import { ProcedureId } from '@/Domain/Procedures'

export class FetchBatchesFromProcedureCommand {
  private _procedureId: ProcedureId

  constructor (procedureId: ProcedureId) {
    this._procedureId = procedureId
  }

  procedureId (): string {
    return this._procedureId.id
  }
}
